import React from 'react';
import styled from 'styled-components';

import * as typography from '../styles/typography';
import * as colors from '../styles/colors';
import { appGutters } from '../styles/constants';
import { device } from '../styles/breakpoints';
import { ReactComponent as LogoSvg } from '../assets/images/regeneron_logo.svg';

const PageWrapper = styled.div`
  background: ${({ theme }) => theme.background};
  box-sizing: border-box;
  color: ${({ theme }) => theme.text};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 32px 24px;

  @media ${device.laptop} {
    padding: 48px ${appGutters};
  }
`;

const MessageArea = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;

const Message = styled.div`
  color: ${colors.black};
  max-width: 640px;
  min-width: 0;
`;

const Heading = styled.p`
  ${typography.bold};
  ${typography.h5};
`;

const Body = styled.p`
  ${typography.regular};
  ${typography.h6};
`;

const RegeneronLogo = styled(LogoSvg)`
  width: 115px;
  margin-top: 16px;
  path {
    fill: ${({ theme }) => theme.foreground};
  }
`;

const FooterText = styled.div`
  font-size: 0.8rem;
  display: flex;
  & > div:first-child {
    flex: 1;
    min-width: 0;
  }
`;

const FooterMetadata = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  & > * {
    margin: 6px 0;
  }

  @media ${device.laptop} {
    padding: 0 16px;
  }
`;

const PortalInactive = () => (
  <PageWrapper>
    <MessageArea>
      <Message>
        <Heading>The EYLEA Payer Policy Portal is no longer active.</Heading>
        <Body>
          For more information on up-to-date coverage and patient resources,
          connect with your Field Reimbursement Manager (FRM) or visit{' '}
          <a
            href="https://www.eyeonaccess.com"
            target="_blank"
            rel="noreferrer"
          >
            EyeOnAccess.com
          </a>
          .
        </Body>
      </Message>
    </MessageArea>
    <Footer>
      <RegeneronLogo />
      <FooterText>
        <div>
          Copyright &copy; 2026, Regeneron Pharmaceuticals, Inc. All rights
          reserved.
        </div>
      </FooterText>
      <FooterText>
        <div>777 Old Saw Mill River Road, Tarrytown, NY 10591</div>
        <FooterMetadata>
          <div>07/2026 US.EHD.26.05.0039</div>
        </FooterMetadata>
      </FooterText>
    </Footer>
  </PageWrapper>
);

export default PortalInactive;
